import React from 'react'

export default function LeagueActiveDot() {
  return (
    <div className='w-[4px] h-[4px] rounded-full bg-[#00A6FF]'/>
  )
}
